module.exports = __webpack_public_path__ + "static/power3-1@2x-b29617906e85acb70f4793acf5b77ef4.png";